import apiConfig from '../../config/api_config';

export const authApi = {
    login: (credentials) => apiConfig.post('/auth/login/', credentials),
    register: (userData) => apiConfig.post('/auth/register/', userData),
    getCurrentUser: async () => {
        const userData = localStorage.getItem('user');
        if (!userData) return null;
        return JSON.parse(userData);
    },
    // Check if email exists (for email-first auth flow)
    checkEmail: (email) => apiConfig.post('/auth/check-email/', { email }),
    // Password reset flow - OTP based (more secure)
    forgotPassword: (email) => apiConfig.post('/auth/forgot-password/', { email }),
    verifyResetCode: (email, reset_code) => apiConfig.post('/auth/verify-reset-code/', { email, reset_code }),
    resetPassword: (email, reset_code, new_password) => apiConfig.post('/auth/reset-password/', { email, reset_code, new_password }),
    resendResetCode: (email) => apiConfig.post('/auth/resend-reset-code/', { email }),
    // Email verification / OTP
    verifyEmail: (email, verification_code) => apiConfig.post('/auth/verify-email/', { email, verification_code }),
    verifyOtp: (data) => apiConfig.post('/auth/verify-email/', { email: data.email, verification_code: data.otp }),
    resendCode: (email) => apiConfig.post('/auth/resend-verification/', { email }),
    resendOtp: (data) => apiConfig.post('/auth/resend-verification/', { email: data.email }),
    refreshToken: () => apiConfig.post('/auth/token/refresh/')
};
